<div nz-row nzJustify="end" [nzGutter]="{ xs: 8, sm: 16, md: 16, lg: 16 }">
  <div nz-col nzLg="8" nzMd="8" nzSm="24" nzXs="24">
    <nz-form-item>
      <nz-form-label nzFor="Date">Date</nz-form-label>
      <nz-form-control [nzSpan]="24" nzErrorTip="Please select a Date!">
        <nz-range-picker
          class="width-100"
          [(ngModel)]="dateRange"
          (ngModelChange)="onChangeDateRange($event)"
        ></nz-range-picker>
      </nz-form-control>
    </nz-form-item>
  </div>
  <div nz-col nzLg="8" nzMd="8" nzSm="24" nzXs="24" class="mb5">
    <div class="mb2">
      <nz-form-label nzFor="chapter">Search</nz-form-label>
      <nz-input-group [nzSuffix]="suffixIconSearch">
        <input
          type="text"
          nz-input
          placeholder="Search by User Name and Mobile no"
          ngModel
          (ngModelChange)="searchTestWithName($event)"
        />
      </nz-input-group>
      <ng-template #suffixIconSearch>
        <i nz-icon nzType="search"></i>
      </ng-template>
    </div>
  </div>
</div>
<div class="insights-wrapper">
  <nz-row [nzGutter]="16">
    <nz-col nzSpan="24">
      <nz-card
        nzTitle="All Attended Users"
        class="insight-card"
        [nzExtra]="allExtra"
      >
        <ng-template #allExtra>
          <button nz-button nzType="link" (click)="toggleAll()">
            <i nz-icon [nzType]="allCollapsed ? 'down' : 'up'"></i>
            <span class="muted">{{ allCollapsed ? "Show" : "Hide" }}</span>
          </button>
        </ng-template>
        <div class="card-subtitle">
          Total attended:
          <strong>{{ totalAllAttended || totalAttended }}</strong>
        </div>
        <div *ngIf="!allCollapsed">
          <nz-table
            #allTable
            [nzData]="allAttended"
            [nzLoading]="loading"
            nzBordered
            [nzTotal]="totalAllAttended || totalAttended"
            [(nzPageSize)]="pageSize"
            [nzPageIndex]="pageIndex"
            [nzFrontPagination]="false"
            nzShowSizeChanger
            (nzQueryParams)="onQueryParamsChange($event)"
          >
            <thead>
              <tr>
                <th>Rank</th>
                <th>User</th>
                <th>Final Marks</th>
                <th>Total Marks</th>
                <th>Percentile</th>
                <th>Time Taken</th>
                <th>Attended At</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of allTable.data">
                <td>{{ item.rank }}</td>
                <td>
                  <div class="user-cell">
                    <nz-avatar
                      nzSize="small"
                      nzText="{{ getInitial(item.user?.name) }}"
                    ></nz-avatar>
                    <div class="user-info">
                      <div class="user-name">{{ item.user?.name || "-" }}</div>
                      <div class="">
                        {{ item.user?.mobile || "-" }}
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <nz-tag [nzColor]="getMarkTagColor(item.finalMarks)">{{
                    item.finalMarks
                  }}</nz-tag>
                </td>
                <td>{{ item.examTotalMarks }}</td>
                <td>{{ formatPercentile(item.examPercentile) }}</td>
                <td>{{ convertMinutes(item.completedTime) }}</td>
                <td>{{ item.attendedAt | date: "medium" }}</td>
              </tr>
            </tbody>
          </nz-table>
        </div>
      </nz-card>
    </nz-col>
  </nz-row>
</div>
